import React from 'react'
import { Box, Image, SxStyleProp } from 'rebass'
import { TextV2 as Text, ICMSTextV2Props } from '../Text/TextV2'
import { IModuleBackgroundColorProps } from '../ModuleSection/ModuleSection'
import { storyCardStyles } from './StoryCard.styles'
import { theme } from '../../../styles/theme'

export interface IStoryCardProps {
  title?: ICMSTextV2Props
  body?: ICMSTextV2Props
  imageSrc: string
  imageAlt: string
  imageSx?: SxStyleProp
  backgroundColor: IModuleBackgroundColorProps
  sx?: SxStyleProp
}

export const StoryCard = ({ title, body, imageSrc, imageAlt, backgroundColor, imageSx, sx }: IStoryCardProps) => {
  const desktopBackgroundColor = theme.v2.colors[backgroundColor.desktop]
  const mobileBackgroundColor = backgroundColor.mobile
    ? theme.v2.colors[backgroundColor.mobile]
    : desktopBackgroundColor

  return (
    <Box
      sx={{
        backgroundColor: [mobileBackgroundColor, mobileBackgroundColor, desktopBackgroundColor],
        ...storyCardStyles,
        ...sx,
      }}
    >
      <Image
        sx={{
          ...(imageSx || {}),
        }}
        src={imageSrc}
        alt={imageAlt}
      />
      <Box
        sx={{
          padding: '15px',
        }}
      >
        {title ? (
          <Text
            tag={title.tag}
            textFontColor={title.textFontColor}
            textFontStyle={title.textFontStyle}
            sx={{
              fontSize: '24px',
              marginBottom: '15px',
              ...title.sx,
            }}
          >
            {title.text}
          </Text>
        ) : null}
        {body ? (
          <Text
            tag={body.tag}
            textFontColor={body.textFontColor}
            textFontStyle={body.textFontStyle}
            sx={{
              ...body.sx,
            }}
          >
            {body.text}
          </Text>
        ) : null}
      </Box>
    </Box>
  )
}
